import { ConsoleLogger } from './console-logger';

const RETRY_DELAYS_MS = [0, 1000, 2000, 5000, 10000, 30000];

export class HubReconnectScheduler {
  private timer: number = null;
  private attempt = 0;

  constructor(private hubName: string, private restart: () => void) {}

  schedule() {
    if (this.timer !== null) {
      return;
    }

    const delay = RETRY_DELAYS_MS[Math.min(this.attempt, RETRY_DELAYS_MS.length - 1)];
    this.attempt++;
    ConsoleLogger.logInfo(`${this.hubName}: reconnect attempt ${this.attempt} in ${delay}ms`);

    this.timer = window.setTimeout(() => {
      this.timer = null;
      this.restart();
    }, delay);
  }

  reset() {
    this.attempt = 0;
    this.cancel();
  }

  cancel() {
    if (this.timer !== null) {
      window.clearTimeout(this.timer);
      this.timer = null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/utilities/hub-reconnect-scheduler.ts